import { render } from "./SoftwareModule.vue?vue&type=template&id=9b2182e8&scoped=true"
import script from "./SoftwareModule.vue?vue&type=script&lang=js"
export * from "./SoftwareModule.vue?vue&type=script&lang=js"

import "./SoftwareModule.vue?vue&type=style&index=0&id=9b2182e8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9b2182e8"

export default script